import React, { useEffect } from "react";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,

} from "../../service/casino";
import { useLocation, useParams } from "react-router-dom";
import {
  getUniversalCasinoPlExposureByRunner,
  GetUniversalLastTenResult,
} from "./genericFunctions";

import toast from "react-hot-toast";
import GenericCasinoTimer from "../../components/GenericCasinoTimer";

export default function GenericPoker() {
  const { id: GAME_ID } = useParams();
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [odds?.roundId]);
 
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);

  // Function to check time condition
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt;
    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);
  return (
    <div style={{ overflowY: "scroll", height: "min-content" }}>
      <app-casino-room _ngcontent-ng-c663229740="" _nghost-ng-c2733776549="">
        <div
          _ngcontent-ng-c2733776549=""
          _ngcontent-ysg-c0=""
          id="playerInfo"
          className="top"
        >
          <div
            _ngcontent-ng-c2733776549=""
            _ngcontent-ysg-c0=""
            className="left_list"
          />
          <div
            _ngcontent-ng-c2733776549=""
            _ngcontent-ysg-c0=""
            className="right_list none-lobby-page hasTimer"
          >
            <ol _ngcontent-ng-c2733776549="" _ngcontent-ysg-c0="">
              <li _ngcontent-ng-c2733776549="" style={{ cursor: "pointer" }}>
                <i
                  _ngcontent-ng-c2733776549=""
                  _ngcontent-cuc-c0=""
                  className="fa fa-cog fa-lg"
                />
              </li>
            </ol>
          </div>
        </div>
        <div
          _ngcontent-ng-c2733776549=""
          id="stackbetsModal"
          aria-labelledby="stackbetsModal"
          aria-hidden="true"
          className="modal fade"
        >
          <div _ngcontent-ng-c2733776549="" className="modal-dialog">
            <div _ngcontent-ng-c2733776549="" className="modal-content">
              <div _ngcontent-ng-c2733776549="" className="modal-header">
                <h3 _ngcontent-ng-c2733776549="" className="mb-0 bold">
                  Stake
                </h3>
              </div>
              <div _ngcontent-ng-c2733776549="" className="stack-modal-body">
                <div
                  _ngcontent-ng-c2733776549=""
                  className="card-body container-fluid container-fluid-5 button-value quick-stake-container"
                >
                  <div
                    _ngcontent-ng-c2733776549=""
                    className="row row5 mb-1 desktop-pl"
                  >
                    <div _ngcontent-ng-c2733776549="" className="col-3">
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="button-title"
                        style={{ fontSize: 14, marginLeft: "-2px" }}
                      >
                        <span _ngcontent-ng-c2733776549="">
                          <b
                            _ngcontent-ng-c2733776549=""
                            className="stake-amount"
                          >
                            Quick Stakes
                          </b>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    _ngcontent-ng-c2733776549=""
                    className="row row5 mb-1 col-md-12 desktop-pl quick-stake-boxes"
                  >
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks0"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks1"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks2"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks3"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks4"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks5"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks6"
                        />
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c2733776549=""
                      className="col-4 col-sm-3 col-md-3 mt-2 quick-box-con"
                    >
                      <div
                        _ngcontent-ng-c2733776549=""
                        className="form-group mb-0 quick-stake-box"
                      >
                        <input
                          _ngcontent-ng-c2733776549=""
                          type="text"
                          min={1}
                          max={99999999}
                          maxLength={9}
                          className="form-control ng-untouched ng-pristine ng-valid"
                          id="quickstacks7"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div _ngcontent-ng-c2733776549="" className="modal-footer">
                  <button _ngcontent-ng-c2733776549="" className="updatebtn">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-casino-room>
      <router-outlet _ngcontent-ng-c663229740="" />
      <app-pocker2020 _nghost-ng-c2934565449="">
        <div _ngcontent-ng-c2934565449="" style={{ overflowY: "hidden" }}>
          <div _ngcontent-ng-c2934565449="">
            <app-video-player
              _ngcontent-ng-c2934565449=""
              _nghost-ng-c595356512=""
            >
              <div _ngcontent-ng-c595356512="" className="videoPlayer">
                <video
                  _ngcontent-ng-c595356512=""
                  id="remoteVideo"
                  width="100%"
                  height="100%"
                  autoplay=""
                  playsinline=""
                  muted=""
                  style={{
                    background:
                      "black 50% / 48% 75% no-repeat  url(https://casino.queenexch.com/assets/loader.gif)",
                  }}
                ></video>

                <div _ngcontent-ng-c595356512="" className="video-overlay">
                  <div _ngcontent-ng-c595356512="" id="game-cards">
                    {odds?.playerCards?.map((player) => (
                      <div _ngcontent-ng-c595356512="">
                        <h3 _ngcontent-ng-c595356512="" className="text-white">
                          {player?.forPerson}
                        </h3>
                        <div _ngcontent-ng-c595356512="">
                          {player?.cards?.map((card) => (
                            <img
                              _ngcontent-ng-c595356512=""
                              src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                  <div
                    _ngcontent-ng-c595356512=""
                    className="mini-result-new resultRemover"
                  ></div>
                </div>

                <div _ngcontent-ng-c595356512="" className="timer-overlay">
                  <GenericCasinoTimer
                    time={odds?.seconds}
                    status={odds?.status}
                  />
                </div>
              </div>
              {showWinnerOverlay && (
                <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                  <div
                    _ngcontent-ng-c595356512=""
                    className="mini-result-new active"
                  >
                    <span _ngcontent-ng-c595356512="">
                      {" "}
                      {odds?.roundWinner} win{" "}
                    </span>
                    {/**/}
                  </div>
                  <span
                    _ngcontent-ng-c595356512=""
                    style={{ position: "absolute" }}
                  >
                    <canvas
                      _ngcontent-ng-c595356512=""
                      width="100vw"
                      height="100vh"
                    />
                  </span>
                  {/**/}
                </div>
              )}

              <div
                _ngcontent-ng-c595356512=""
                id="rulesModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabelaexampleModalLabela"
                aria-hidden="true"
                className="modal fade"
              >
                <div
                  _ngcontent-ng-c595356512=""
                  className="modal-dialog rules-wrap"
                >
                  <div
                    _ngcontent-ng-c595356512=""
                    role="document"
                    id="rulesList___BV_modal_content_"
                    tabIndex={-1}
                    className="modal-content rules-content"
                  >
                    <header
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_header_"
                      className="rules-wrap"
                    >
                      <a _ngcontent-ng-c595356512="">
                        <h3
                          _ngcontent-ng-c595356512=""
                          id="rulesList___BV_modal_title_"
                          data-bs-toggle="modal"
                          data-bs-target="#rulesModal"
                          className="modal-title"
                        >
                          {" "}
                          Rules
                        </h3>
                      </a>
                      <button
                        _ngcontent-ng-c595356512=""
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        className="close"
                      >
                        ×
                      </button>
                    </header>
                    <div
                      _ngcontent-ng-c595356512=""
                      id="rulesList___BV_modal_body_"
                      className="modal-body"
                    >
                      <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                    </div>
                    <div _ngcontent-ng-c595356512="">
                      <ul
                        _ngcontent-ng-c595356512=""
                        className="btn-wrap break"
                      >
                        <li _ngcontent-ng-c595356512="">
                          <a
                            _ngcontent-ng-c595356512=""
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            className="btnok"
                          >
                            OK
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </app-video-player>
          </div>
          <div _ngcontent-ng-c2934565449="" className="poker-con">
            <div _ngcontent-ng-c2934565449="" className="row">
              <div _ngcontent-ng-c2934565449="" className="col-6 playerA">
                <span _ngcontent-ng-c2934565449="">player A</span>
              </div>
              <div _ngcontent-ng-c2934565449="" className="col-6 playerB">
                <span _ngcontent-ng-c2934565449="">Player B</span>
              </div>
            </div>
          </div>
          <div
            _ngcontent-ng-c2934565449=""
            id="marketScroll"
            style={{ overflowY: "auto", height: 725, paddingBottom: 150 }}
            className="overflow-auto"
          >
            <div _ngcontent-ng-c2934565449="">
              {odds?.markets?.map((item) => (
                <div _ngcontent-ng-c2934565449="">
                  <div _ngcontent-ng-c2934565449="" className="row">
                    <div _ngcontent-ng-c2934565449="">
                      <div
                        _ngcontent-ng-c2934565449=""
                        className="win-mark-con col-12"
                      >
                        {item?.marketName == "LUCKY 9" ? (
                          <span
                            _ngcontent-ng-c2817653786=""
                            style={{
                              position: "absolute",
                              textAlign: "center",
                              top: "1px",
                            }}
                          >
                            <img
                              _ngcontent-ng-c2817653786=""
                              src="https://casino.queenexch.com/assets/lucky9.png"
                              alt="lucky9"
                              class="lucky9-img"
                            />
                          </span>
                        ) : (
                          <span
                            _ngcontent-ng-c2934565449=""
                            className="market-name-section"
                            style={{
                              position: "absolute",
                              textAlign: "center",
                              paddingTop: "3.5px",
                            }}
                          >
                            <b _ngcontent-ng-c2934565449="">
                              {item?.marketName}
                            </b>
                            <span
                              _ngcontent-ng-c2934565449=""
                              className="minMaxMbl-desk"
                            >
                              <i
                                _ngcontent-ng-c2934565449=""
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="fa fa-info-circle ml-2"
                                data-bs-target="#collapse121"
                                id="#collapse12972402142220"
                              />
                              <ul
                                _ngcontent-ng-c2934565449=""
                                className="dropdown-menu icon-range min-max-info text-end tooltip-betlimit"
                                aria-labelledby="collapse12972402142220"
                              >
                                <span _ngcontent-ng-c2934565449="">
                                  Min/Max: {item?.min} - {item?.max}{" "}
                                </span>
                              </ul>
                            </span>
                          </span>
                        )}
                        {item?.marketName == "LUCKY 9" ? (
                          <>
                            <div
                              _ngcontent-ng-c2817653786=""
                              className="d-flex justify-content-between dyna-pos l-dyna-pos back-section"
                            >
                              <div
                                _ngcontent-ng-c2817653786=""
                                appratehighlight=""
                                className="back-1 count sportbook-minwidth p-rltv"
                              >
                                <div
                                  _ngcontent-ng-c2817653786=""
                                  className="inside-back"
                                >
                                  <a
                                    _ngcontent-ng-c2817653786=""
                                    className="d-flex flex-column p-0"
                                    style={{ textDecoration: "none" }}
                                  >
                                    <b
                                      _ngcontent-ng-c2817653786=""
                                      className="inside-back-price"
                                      style={{
                                        fontSize: 16,
                                        position: "relative",
                                        top: 2,
                                      }}
                                    >
                                      {item?.oddDetailsDTO[0]?.back1}
                                    </b>
                                    <span
                                      _ngcontent-ng-c2817653786=""
                                      className="d-flex justify-content-center inside-back-size"
                                      style={{
                                        position: "relative",
                                        bottom: 2,
                                      }}
                                    >
                                      {item?.oddDetailsDTO[0]?.backSize1}
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>

                            <div
                              _ngcontent-ng-c2817653786=""
                              className="d-flex justify-content-between dyna-pos l-dyna-pos lay-section"
                            >
                              <div
                                _ngcontent-ng-c2817653786=""
                                appratehighlight=""
                                className="back-1 count sportbook-minwidth p-rltv"
                              >
                                <div
                                  _ngcontent-ng-c2817653786=""
                                  className="inside-back"
                                >
                                  <a
                                    _ngcontent-ng-c2817653786=""
                                    className="d-flex flex-column p-0"
                                    style={{ textDecoration: "none" }}
                                  >
                                    <b
                                      _ngcontent-ng-c2817653786=""
                                      className="inside-back-price"
                                      style={{
                                        fontSize: 16,
                                        position: "relative",
                                        top: 2,
                                      }}
                                    >
                                      {item?.oddDetailsDTO[0]?.lay1}
                                    </b>
                                    <span
                                      _ngcontent-ng-c2817653786=""
                                      className="d-flex justify-content-center inside-back-size"
                                      style={{
                                        position: "relative",
                                        bottom: 2,
                                      }}
                                    >
                                      {item?.oddDetailsDTO[0]?.laySize1}
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            {item?.oddDetailsDTO[0]?.status == "SUSPEND" && (
                              <div
                                _ngcontent-ng-c2934565449=""
                                className="suspended-casino poker-suspnd"
                              >
                                <span
                                  _ngcontent-ng-c2934565449=""
                                  className="stats-text"
                                >
                                  Suspended
                                </span>
                              </div>
                            )}
                            {item?.oddDetailsDTO &&
                              item?.oddDetailsDTO?.length > 0 && (
                                <div
                                  _ngcontent-ng-c2934565449=""
                                  className="profitloss"
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    bottom: "-10px",
                                  }}
                                >
                                  {getUniversalCasinoPlExposureByRunner(
                                    exposure,
                                    item?.oddDetailsDTO[0]?.runnerName,
                                    item?.oddDetailsDTO[0]?.selectionId
                                  )}
                                </div>
                              )}
                          </>
                        ) : (
                          item?.oddDetailsDTO?.map((odd, index) => (
                            <>
                              <div
                                _ngcontent-ng-c2934565449=""
                                className="d-flex justify-content-between dyna-pos"
                              >
                                <div
                                  _ngcontent-ng-c2934565449=""
                                  appratehighlight=""
                                  className={`back-1 count sportbook-minwidth p-rltv ${
                                    placeBetPayload?.runnerName ==
                                      odd?.runnerName &&
                                    placeBetPayload?.marketIdWithSelectionId?.split(
                                      "_"
                                    )[1] == odd?.selectionId
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <div
                                    _ngcontent-ng-c2934565449=""
                                    className="inside-back"
                                  >
                                    <a
                                      _ngcontent-ng-c2934565449=""
                                      className="d-flex flex-column p-0"
                                      style={{ textDecoration: "none" }}
                                    >
                                      <b
                                        _ngcontent-ng-c2934565449=""
                                        className="inside-back-price"
                                        style={{
                                          fontSize: 16,
                                          position: "relative",
                                          top: 2,
                                        }}
                                      >
                                        {odd?.back1}
                                      </b>
                                      <span
                                        _ngcontent-ng-c2934565449=""
                                        className="d-flex justify-content-center inside-back-size"
                                        style={{
                                          position: "relative",
                                          bottom: 2,
                                        }}
                                      >
                                        {odd?.backSize1}
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div
                                _ngcontent-ng-c2934565449=""
                                className="profitloss"
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent:
                                    index % 2 == 0 ? "flex-start" : "flex-end",
                                }}
                              >
                                {getUniversalCasinoPlExposureByRunner(
                                  exposure,
                                  odd?.runnerName,
                                  odd?.selectionId
                                )}
                              </div>
                              {odd?.status == "SUSPEND" && (
                                <div
                                  _ngcontent-ng-c2934565449=""
                                  className="suspended-casino poker-suspnd"
                                >
                                  <span
                                    _ngcontent-ng-c2934565449=""
                                    className="stats-text"
                                  >
                                    Suspended
                                  </span>
                                </div>
                              )}
                            </>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <GetUniversalLastTenResult lastResult={lastResult} />
          </div>
        </div>
      </app-pocker2020>
    </div>
  );
}
